import { PLATFORM } from 'aurelia-framework';

export const tabRoutes = [
  {
    route: [''],
    name: 'tab-service-kpi-antifouling',
    moduleId: PLATFORM.moduleName('./tab-service-kpi-antifouling'),
    tabindex: 0,
    entityShortName: 'tab-service-kpi-antifouling',
  },
  {
    route: ['/estimates-service-queue'],
    name: 'tab-service-kpi-estimates-service-queue',
    moduleId: PLATFORM.moduleName('./tab-service-kpi-estimates-service-queue'),
    tabIndex: 1,
    entityShortName: 'tab-service-kpi-estimates-service-queue',
  },
];
